import { Badge } from 'antd'
import ButtonComponent from '../Buttons/button-component'
import styles from './sociogram-info-card.module.scss'
import { FileSearchOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useGetSurveyParticipantsTerminateds } from '@BUP/hooks/Sociogram/participantsTerminated/useGetSurveyParticipantsTerminateds'
import BupSpinner from '@BUP/components/Loading/Spinner'
import { useNavigate } from 'react-router-dom'
import UpdateSurveyButton from '../Buttons/update-survey-button'
import { capitalizeFirst } from '@BUP/utils'

const SociogramInfoCard = ({ survey }) => {
  const i18n = useTranslation()
  const navigate = useNavigate()
  const { isActive, isDone, participants, id: surveyId } = survey
  const { isLoadingParticipantsTerminated, participantsTerminated } =
  useGetSurveyParticipantsTerminateds(survey.id)

  const notActivated = !isActive && !isDone
  const isActivated = isActive && !isDone

  const handleViewCourseList = () => {
    navigate(`/sociogram/students-list/${surveyId}`)
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header_title}>
          <FontAwesomeIcon icon={faGraduationCap} className={styles.header_icon} />
          <h3>{capitalizeFirst(i18n.t('common.resources.survey.text'))}: </h3>
          <span>
            <Badge
              color={isActivated ? '#45cbc9' : '#a9b2b2'}
              text={capitalizeFirst(
                notActivated
                  ? i18n.t('common.resources.survey.actions.read.state.not_active')
                  : isActivated
                    ? i18n.t('common.resources.survey.actions.read.state.active')
                    : i18n.t('common.resources.survey.actions.read.state.closed')
              )}
            />

          </span>
        </div>
        <div className={styles.content_wrapper}>
          <ButtonComponent
            buttonText={(i18n.t('common.resources.survey-response.label', { count: 2 }))}
            icon={<FileSearchOutlined />} onClick={() => handleViewCourseList()}
          />
          <UpdateSurveyButton
            survey={survey}
          />
          <div>{
            isLoadingParticipantsTerminated
              ? <BupSpinner size='small' />
              : `${capitalizeFirst(i18n.t('common.resources.survey-response.label', { count: 1 }))}: ${participantsTerminated.length} / ${!participants ? '--' : participants.length}`
          }
          </div>
        </div>
      </div>
    </div>
  )
}

export default SociogramInfoCard
